<rx-text-input
	[label]="('OrderSection.CurrentAligner' | translate) + ' #:'"
	[formControl]="control"
	[isDisabled]="isReadOnly || control.disabled"
	autocomplete="off"
	name="currentAlignerId"
>
	<ng-container tlk-error>
		{{ 'OrderSection.AlignerIdLengthErrorMessage' | translate: { minValue: '0', maxValue: maxValue.toString() } }}
	</ng-container>
</rx-text-input>
